import React from 'react';
import {Link} from 'react-router-dom';
import AurBanner from '../../../common/aur-banner/AurBanner';
import './Banner.scss';

const Banner: React.FC = () => {
  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Banner</h1>
        <div>
          Banners display brief messages for the user without interrupting their
          use of the app.
        </div>
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <AurBanner
            errorText="The was an error. Contact your Administrator."
            errorType="error"
          />
        </div>
      </div>
    </>
  );
};

export default Banner;
